export default __webpack_public_path__ + "static/new-approach-9da68b66b4e264756219f780ec070255.png";